import React from 'react';
import ContactForm from '../components/ContactElements/ContactForm';
import Map from '../components/ContactElements/Map';

const ContactUs = () => {
    return (
        <div className="contact homestyle">
            <div className="gmap_wrapper">
                <div className="gmapbox">
                    <div id="googleMap" className="map">
                        <Map />
                    </div>
                    <ContactForm />
                </div>
            </div>
        </div>
    );
};

export default ContactUs;